export const sidebarList = [
  "Antennas",
  "Cavity Filters",
  "Ceramic and SAW",
  "LNA",
  "Non-Ferrous Metals",
  "RF Adapters",
  "RF Cable Assembly",
  "RF Cables",
  "RF Connectors",
  "Waveguides",
];
